import { StyleSheet } from 'aphrodite'

import Colours from '@thebeansgroup/ui_style_helpers/colours'

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    backgroundColor: Colours('white', '300'),
    borderRadius: 5,
    textAlign: 'center',
    width: '90vw',
    maxWidth: '460px'
  },
  bodyContainer: {
    padding: '24px'
  },
  text: {
    paddingTop: '8px'
  },
  button: {
    paddingTop: '24px'
  },
  closeButtonContainer: {
    position: 'absolute',
    top: '16px',
    right: '16px'
  }
})

export default styles
